import { motion } from "framer-motion";
import { WHATSAPP_NUMBER } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export const WhatsAppButton = () => {
  const { t } = useLang();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t.whatsapp.msg)}`;
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={t.whatsapp.label}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      className="group fixed bottom-24 right-4 z-40 flex items-center gap-3 rounded-full bg-[#25D366] p-4 text-white shadow-[0_12px_32px_-8px_rgba(37,211,102,0.7)] md:bottom-8 md:right-8 md:px-5"
      style={{ color: "#FFFFFF" }}
    >
      <span className="brand-mask relative h-7 w-7" style={{ WebkitMaskImage: "url(/brands/whatsapp.svg)", maskImage: "url(/brands/whatsapp.svg)" }} />
      <span className="font-display relative hidden text-sm font-extrabold uppercase tracking-wider md:inline">{t.whatsapp.short}</span>
    </motion.a>
  );
};
